import React from 'react';
import ContactForm from './ContactForm';

const cardsText = {
  firstList: [
    {
      firstLine: 'Python',
      secondLine: 'Development',
      id: 'python-dev',
      name: 'Python Development',
      value: 'Python Development'
    },
    {
      firstLine: 'Cryptocurrency &',
      secondLine: 'Trading',
      id: 'crypto',
      name: 'Cryptocurrency & Trading',
      value: 'Cryptocurrency & Trading'
    },
    {
      firstLine: 'MVP',
      secondLine: 'Development',
      id: 'mvp-dev',
      name: 'MVP Development',
      value: 'MVP Development'
    },
    {
      firstLine: 'Team Extension',
      id: 'team-ext',
      name: 'Team Extension',
      value: 'Team Extension'
    },
    {
      firstLine: 'Other',
      id: 'other',
      name: 'Other',
      value: 'Other'
    }
  ],
  secondList: [
    {
      firstLine: 'Below $10,000',
      id: 'below-10000',
      name: 'radio',
      value: 'Below $10,000'
    },
    {
      firstLine: '$10,000 to ',
      secondLine: '$25,000',
      id: '10000 to 25000',
      name: 'radio',
      value: '$10,000 to $25,000'
    },
    {
      firstLine: '$25,000 to ',
      secondLine: '$50,000',
      id: '12000 to 50000',
      name: 'radio',
      value: '$25,000 to $50,000'
    },
    {
      firstLine: '$50,000 to',
      secondLine: '$100,000',
      id: '50000 to 100000',
      name: 'radio',
      value: '$50,000 to $100,000'
    },
    {
      firstLine: 'Above $100,000',
      id: 'above 100000',
      name: 'radio',
      value: 'Above $100,000'
    },
    {
      firstLine: 'Not specified',
      id: 'not-spec',
      name: 'radio',
      value: 'Not specified'
    }
  ]
};

export default ({ location }) => {
  return (
    <div className="main-beam-wrapper">
      <div>
        <ContactForm location={location} cardsText={cardsText} />
      </div>
    </div>
  );
};
